import { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import Space from "../ui/Space";
import Label from "../ui/Label";

export default function ClassSelection(props) {
    const { controller = "", callback = () => { }, value = "", route = "" } = props;
    const [filters, setFilters] = useState({ sort: "category", limit: 45, dynamic: true });
    const [align, setAlign] = useState("auto");
    const [loading, setLoading] = useState(false);
    const buffer = 10;
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    
    const fetchInitial = () => {
        if (loading) { return }
        setLoading(true);

        let _filters = { ...filters };
        _filters.search_term = props?.search;
        let _api = "category.search";
        if (!_filters?.search_term) {
            _filters.search_term = "?";
        }

        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                setAlign("start");
            } else {
                showError(_r);
                setLoading(false);
                if (_api === "category.search") {
                    setFilters({ ...filters, "search_term": "" })
                }
            }
            setLoading(false)
        });
    }

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("category.getNext", { ...filters, "limit": 20, "category_id": data[data.length - 1]?.category_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }   
            setLoading(false);
        })
    }

    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("category.getPrevious", { ...filters, "limit": 20, "category_id": data[0]?.category_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }
    

    useEffect(() => {
        fetchInitial(props.search);
    }, []);

    const nav = [
        { key: KBD.ESCAPE, action: () => { callback() } },
        { key: KBD.ENTER, action: (e) => { callback(selected) }},
        { key: KBD.ARROW_DOWN, action: () => { nextType() } },
        { key: KBD.ARROW_UP, action: () => { prevType() } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [KBD.ESCAPE, KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [selected, data]);
    

    const columns = [
        { key: "class", align: "left", title: <>Classification</>, width: 240, render : (e, f) => {
            return(
                <Space>
                    <div width={65} style={{"textAlign" : "left"}}>{f.category_1}</div>
                    <Label width={10} style={{"textAlign" : "center"}}>-</Label>
                    <div width={65} style={{"textAlign" : "left"}}>{f.category_2}</div>
                </Space>
            )
        }},
        { key: "section", align: "left", title: <>Se</>, width: 40},
        { key: "tax_code", align: "left", title: <>Tx</>, width: 30},
    ]

    const nextType = (_rows = 1) => {

        if (data.length === 0) { setSelected({}); return; }

        setAlign("auto")
        const nextIndex = data.findIndex(item => item?.category_id === selected?.category_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prevType = (_rows = 1) => {
        setAlign("auto")
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.category_id === selected?.category_id) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };


    return (
        <>
            <VirtualTable
                controller={controller}
                row_key={"category_id"}
                next={nextType}
                prev={prevType}
                columns={columns}
                onRowClick={(item) => { setAlign("auto"); setSelected(item) }}
                onRowDoubleClick={() => { callback(selected) }}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
                align={align}
                loading={loading}
                onLoadMore={(_start, _end, _prepend) => {
                    if (_prepend) {
                        if (data?.length > 0 && data[0]?.number !== 1) {
                            fetchPrev()
                        }
                    } else {
                        if (data?.length > 0) {
                            fetchNext();
                        }
                    }
                }}
                getStart={() => fetchInitial()}
                route={route}
                current={selected}
                data={data}
                width={310}
                height={440}
            />
        </>
    )

}
